// ============================================================================
// LIS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'lis',
  name: 'LIS',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(N log N)',
    space: 'O(N)'
  },
  description: 'Longest Increasing Subsequence: finds the longest subsequence of a sequence in which the elements are in increasing order. The optimal solution uses binary search with a patience sorting approach for O(N log N) time.'
};
